/* sg-blog-shelf: coloca los libros y abre el activo. Toca un lomo para abrirlo; cambia solo cada N segundos. */
if (!customElements.get('sg-shelf')) {
  class SgShelf extends HTMLElement {
    connectedCallback() {
      this.books = Array.from(this.querySelectorAll('.sg-bk'));
      if (this.books.length < 2) return;
      this.stage = this.querySelector('.sg-shelf__stage');
      this.active = 0;
      this.seconds = parseInt(this.dataset.autoplay, 10) || 0;
      this.paused = false;

      this.classList.add('is-armed');
      this.books.forEach((book, i) => {
        book.addEventListener('click', (e) => {
          if (i === this.active) return;
          e.preventDefault();
          this.open(i);
          this.restart();
        });
      });
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', () => { this.paused = false; });

      this.onResize = () => this.layout();
      window.addEventListener('resize', this.onResize);
      this.layout();
      this.restart();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      clearInterval(this.timer);
    }

    num(name) {
      return parseFloat(getComputedStyle(this).getPropertyValue(name)) || 0;
    }

    layout() {
      const d = this.num('--sg-bk-d');
      const c = this.num('--sg-bk-c');
      const sa = this.num('--sg-bk-sa') * Math.PI / 180;
      const ca = this.num('--sg-bk-ca') * Math.PI / 180;
      const gap = parseFloat(getComputedStyle(this.stage).columnGap) || (d > 40 ? 16 : 7);
      const spineVis = d * Math.cos(sa);
      const coverVis = c * Math.cos(ca);
      const half = this.stage.clientWidth / 2;

      const widths = this.books.map((_, i) => (i === this.active ? spineVis + coverVis : d));
      let acc = 0;
      const xs = widths.map((w) => { const x = acc; acc += w + gap; return x; });
      const offset = half - (xs[this.active] + widths[this.active] / 2);
      this.books.forEach((book, i) => {
        const shift = i === this.active ? d - spineVis : 0;
        book.style.setProperty('--sg-bk-x', (xs[i] + offset - shift).toFixed(2) + 'px');
      });
    }

    open(i) {
      this.active = i;
      this.books.forEach((book, j) => book.classList.toggle('is-on', j === i));
      this.layout();
    }

    restart() {
      clearInterval(this.timer);
      if (!this.seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden) this.open((this.active + 1) % this.books.length);
      }, this.seconds * 1000);
    }
  }
  customElements.define('sg-shelf', SgShelf);
}
